import React, { useContext, useState, useEffect, useLayoutEffect } from 'react';
import {
  Widget,
  FormSelect,
  SimpleView,
  MasterDetailForm,
  GridView,
  Row,
  InlineEditTable,
  InlineEditColumnProps,
  Table,
  FormText,
  Button,
  FormInput,
} from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon, Input } from 'antd';
import { ProjetoPacote } from '@app/api/projeto';
import { AcronimoPacote } from '@app/api/acronimosPacote';
import { OrcamentoAcronimoPacote, ResumoRfa } from '@app/api/ordemInvestimento';
import { Link } from 'react-router-dom';

interface FormResumoRFaProjetoProps {
  resumoRfa: ResumoRfa[];
  projetoId: string;
}

interface FormOrcadoProjetoProps { }

const { Panel } = Collapse;

const FormTableOrcadoRfaProjeto = (props: FormResumoRFaProjetoProps) => {
  const { resumoRfa, projetoId } = props;

  const [resumoHeader, setResumoHeader] = useState<string>();
  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = async () => {
      if (resumoRfa.length > 0) {
        let capex = resumoRfa[0];
        if (capex) {
          var header = capex.numero + ' - ' + capex.revisao + ' - ' + capex.dataAprovacao;
          setResumoHeader(header);
          setValorTotal(capex.valorTotalCurrency);
        }
      }
    };

    getData();
  }, [resumoRfa]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Oi',
        dataIndex: 'oi',
        width: '2%',
      },
      {
        title: 'Código do pacote',
        dataIndex: 'codigoPacote',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
      },
      {
        title: 'Valor Rfa',
        dataIndex: 'valor',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorCurrency',
            width: '1%',
          },
        ],
      },
    ] as InlineEditColumnProps<ResumoRfa>[];
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo orçado Rfa" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                projetoId && (
                  <Button
                    title="CONSULTAR DISTRIBUIÇÃO RFA"
                    type="primary"
                    icon="commons-search"
                    onClick={() => {
                      window.location.href = `/moduloOrcado/PlanilhaRfa/detail/${projetoId}`;
                    }}
                  />
                ),
              ]}>
              <Row>
                {resumoHeader && (
                  <FormInput label="Planilha RFA atual" name="numero" value={resumoHeader || ''} span={3} disabled />
                )}
              </Row>
              <Row>
                <FormText label="" name="v" />
              </Row>
              <Row>
                <Table rowKey="index" columns={customColumns()} dataSource={resumoRfa || []} />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableOrcadoRfaProjeto;
